/**
 * @see https://stackoverflow.com/questions/30106476/using-javascripts-atob-to-decode-base64-doesnt-properly-decode-utf-8-strings
 */

const atob = require('atob');
const btoa = require('btoa');

/**
 * Encodes any possible string format to base64 value
 * @param   {String}    str To be encoded
 * @return  {String|*}  String base64 representation or original value
 */
const encode = str =>
    (!!str && typeof str === 'string'
        ? btoa(encodeURIComponent(str)
            .replace(/%([0-9A-F]{2})/g, (match, p1) => String.fromCharCode(`0x${p1}`)))
        : str);

/**
 * Decodes a base64 value into its original value
 * @param   {String}    str To decode
 * @return  {*}         Original value
 */
const decode = str =>
    (!!str && typeof str === 'string'
        ? decodeURIComponent(atob(str)
            .split('')
            .map(c => `%${(`00${c.charCodeAt(0).toString(16)}`).slice(-2)}`)
            .join(''))
        : str);

module.exports = {
    encode,
    decode
};
